import Api from "..";
import PrivateUser from "../../dtos/user";
import { UserValidationInput } from "../../dtos/user/validation";
import transform from "../../service/transform";

export default class UserValidationApi extends Api {
  constructor() {
    super("user/validation");
  }

  public async get(): Promise<PrivateUser[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("PrivateUser entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(PrivateUser)(value))
    );
  }

  public async put(id: string, data: UserValidationInput): Promise<void> {
    await super.put(id, data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
